import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { Numeric } from '@blade/ui-kit'

import type { Trade } from '@root/entities/trade'
import type { ClassNameProps } from '@root/shared/react'

type TradeAmountCellProps = {
  value: Trade.Trade
} & ClassNameProps

export const TradeAmountCell: React.FC<TradeAmountCellProps> = ({
  className,
  value,
}) => (
  <Root className={className}>
    <StyledTypography>
      <Numeric value={value.currencyAmount} preset="currency-amount-short" />
    </StyledTypography>
  </Root>
)

const Root = styled.div`
  display: grid;
  align-items: center;
  gap: 5px;
  justify-content: start;
  grid-auto-flow: column;
  color: var(--row-color);
`

const StyledTypography = styled(Typography)`
  justify-self: end;
`
